// @ts-ignore - Type import from vue-router causes conflicts with Ionic Vue Router
import type { RouteRecordRaw } from 'vue-router';

const cateringRoutes: Array<RouteRecordRaw> = [
    {
        path: '/catering',
        name: 'Catering',
        meta: {
            seo: {
                title: 'Donatos Catering',
                description: "Having a Party? We'll Bring the Food! Feed the whole crew—as low as $6 per person. We'll handle every detail. Get started planning your event.",
                keywords: ['Donatos catering', 'pizza catering', 'event catering', 'affordable catering options'],
            },
        },
        component: () => import('@/views/catering/cateringPage.vue'),
    },
];

export default cateringRoutes;
